module.exports = __webpack_public_path__ + "static/media/robotx.3b1742b5.png";